var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDeals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Transfers",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transfers-|-Deals---No-Deals-(Desktop)",
    transform: "translate(-205.000000, -250.000000)",
    fill: "#B2B2B2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(115.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(90.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,50 C11.1928813,50 0,38.8071187 0,25 C0,11.1928813 11.1928813,0 25,0 C38.8071187,0 50,11.1928813 50,25 C49.9846913,38.8007727 38.8007727,49.9846913 25,50 Z M25,2.93888889 C12.8159848,2.93888889 2.93888889,12.8159848 2.93888889,25 C2.93888889,37.1840152 12.8159848,47.0611111 25,47.0611111 C37.1840152,47.0611111 47.0611111,37.1840152 47.0611111,25 C47.0488617,12.8210622 37.1789378,2.95113827 25,2.93888889 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16,
    cy: 20,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 34,
    cy: 20,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1370432,38.1485166 C13.8939022,37.6340778 13.9789308,37.0296085 14.3552544,36.5972512 C16.7926958,34.0155259 20.1229635,32.3935426 23.7124293,32.0399052 C27.6869575,31.7313062 31.6614856,33.2136835 35.5678791,36.4484624 C36.1172707,36.9903844 36.1463539,37.8507547 35.6347417,38.4264608 C35.1231294,39.0021669 34.2419941,39.100592 33.6090045,38.652741 C30.3612471,35.9524997 27.1134898,34.7070823 23.9565789,34.949553 C21.1614915,35.237022 18.5669672,36.4931479 16.6491249,38.4874201 C16.3606539,38.8167861 15.9362069,39.0045859 15.4908339,38.9999149 C14.9077051,38.994713 14.3801842,38.6629554 14.1370432,38.1485166 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDeals);
export default __webpack_public_path__ + "static/media/no-deals.2dcf843dba4a16a24648bdefaf006c53.svg";
export { ForwardRef as ReactComponent };